export default class XmlNodeStringFormat {
  static ConceptNodeStart = conceptsIds => {
    return `<Concept id="${conceptsIds}">`;
  };

  static ConceptNodeEnd = () => {
    return `</Concept>`;
  };

  static FormatNodeStart = (id, version, agentId, totalWeight) => {
    return `<?xml version="1.0" encoding="UTF-8"?> <Format id="${id}" version="${version}" agentId="${agentId}" totalWeight="${totalWeight}">`;
  };

  static FormatNodeEnd = () => {
    return `</Format>`;
  };

  static QuestionNode = (questionId, answerId, answerWeight, answerLabel) => {
    return `<Question id="${questionId}" answerId="${answerId}" answerWeight="${answerWeight}" answerLabel="${answerLabel}" />`;
  };
}
